import { object, string, number } from 'yup'

const alphanumericMax3 = (label: string) =>
  string()
    .required(`${label} es requerido`)
    .max(3, 'Máximo 3 caracteres')
    .matches(/^[a-zA-Z0-9]+$/, 'Solo caracteres alfanuméricos')

const alphanumericMax3Optional = () =>
  string()
    .nullable()
    .max(3, 'Máximo 3 caracteres')
    .matches(/^[a-zA-Z0-9]*$/, 'Solo caracteres alfanuméricos')

export const positionValidationSchema = (
  isRequired: boolean,
  requiresLayout: boolean
) =>
  object({
    aisle: requiresLayout
      ? alphanumericMax3('Pasillo')
      : alphanumericMax3Optional(),
    column: requiresLayout
      ? alphanumericMax3('Columna')
      : alphanumericMax3Optional(),
    level: requiresLayout
      ? alphanumericMax3('Nivel')
      : alphanumericMax3Optional(),
    slot: alphanumericMax3Optional(),
    positionName: string()
      .required('El código de posición es requerido')
      .max(50, 'Máximo 50 caracteres')
      .matches(
        /^[A-Z0-9]+(-[A-Z0-9]+)*$/,
        'Solo acepta alfanuméricos y guion medio, no acepta espacios'
      ),
    positionDescription: string().trim().max(200, 'Máximo 200 caracteres.'),
    typePositionId: number()
      .required('Debe seleccionar un tipo de posición')
      .min(1, 'Debe seleccionar un tipo de posición'),
    warehouseId: number()
      .required('Debe seleccionar un almacén')
      .min(1, 'Debe seleccionar un almacén'),
    zoneId: number().when([], {
      is: () => isRequired,
      then: (s) => s.required('Tipo de Ubicación Requiere Zona'),
      otherwise: (s) => s
    }),
    positionAttributes: object({
      maxCapacity: number()
        .required('La capacidad máxima es requerida')
        .min(1, 'Debe ser mayor a 0')
        .max(2147483647, 'Valor máximo permitido: 2.147.483.647')
    })
  })
